import { CalendarHolidaysRepository } from "./adapters/repository";

import * as createCalendarHolidays from "./useCases/createCalendarHolidays";
import * as retrieveCalendarsHolidays from "./useCases/retrieveCalendarsHolidays";
import * as removeCalendarHolidays from "./useCases/removeCalendarHolidays";
import * as editCalendarHolidays from "./useCases/editCalendarHolidays";
import * as removeHoliday from "./useCases/removeHoliday";

enum UseCases {
  createCalendarHolidays = "createCalendarHolidays",
  retrieveCalendarsHolidays = "retrieveCalendarsHolidays",
  removeCalendarHolidays = "removeCalendarHolidays",
  editCalendarHolidays = "editCalendarHolidays",
  removeHoliday = "removeHoliday",
}

interface Core {
  [UseCases.createCalendarHolidays]: createCalendarHolidays.Interactor;
  [UseCases.retrieveCalendarsHolidays]: retrieveCalendarsHolidays.Interactor;
  [UseCases.removeCalendarHolidays]: removeCalendarHolidays.Interactor;
  [UseCases.editCalendarHolidays]: editCalendarHolidays.Interactor;
  [UseCases.removeHoliday]: removeHoliday.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: CalendarHolidaysRepository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.createCalendarHolidays]: createCalendarHolidays.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveCalendarsHolidays]:
      retrieveCalendarsHolidays.createInteractor(dependencies.repository),
    [UseCases.removeCalendarHolidays]: removeCalendarHolidays.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editCalendarHolidays]: editCalendarHolidays.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeHoliday]: removeHoliday.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
